import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DprActivityModelReport } from '@report/models';
import { SubprojectConfiguration } from '@shared/models/project-setup';

@Component({
  selector: 'app-report-activities',
  templateUrl: './report-activities.component.html',
  styleUrls: ['./report-activities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportActivitiesComponent {
  @Input({ required: true }) activitiesModel: DprActivityModelReport[];
  @Input({ required: true }) activityType: number;
  @Input({ required: true }) subprojectConfiguration: SubprojectConfiguration;

  get activityModel(): DprActivityModelReport {
    return this.activitiesModel.find(
      (a) => a.parallelActivityType === this.activityType
    );
  }

  get inlineCustomDataLength(): number {
    return this.activityModel?.inlineCustomData.length;
  }
}
